import React, { useState } from "react";
import "./Header.css";

const Header = () => {
  const [menuAbierto, setMenuAbierto] = useState(false);

  const toggleMenu = () => setMenuAbierto(!menuAbierto);

  return (
    <header>
      <button
        className="menu-hamburguesa"
        onClick={toggleMenu}
        aria-label="Abrir menú"
        aria-expanded={menuAbierto}
      >
        <span />
        <span />
        <span />
      </button>
      <nav className={menuAbierto ? "abierto" : ""}>
        <ul onClick={() => setMenuAbierto(false)}>
          <li>
            <a href="#about">Sobre mí</a>
          </li>
          <li>
            <a href="#experience">Experiencia</a>
          </li>
          <li>
            <a href="#projects">Proyectos</a>
          </li>
          <li>
            <a href="#juego">Juego</a>
          </li>
          <li>
            <a href="#contact">Contacto</a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
